import makeApi from '../client/api'
import { authenticateCrawlerConversion } from './auth'

const removeCrawlerData = async (announcementId, { source, sourceId, token }) => {
  const { accessToken, user } = await authenticateCrawlerConversion(announcementId, { source, sourceId, token })
  const api = makeApi({ token: accessToken })

  const rawAnnouncement = await api.delete('/announcements/raw', { id: announcementId })
  await api.delete('/users', { id: user.id })

  return rawAnnouncement
}

export default removeCrawlerData
